import React from "react";
import PropTypes from "prop-types";
import ContentLoader from "react-content-loader";
import classNames from "classnames";

// Constants
const LOADER_DEFAULT_PROPS = {
  height: 70,
  width: 350,
  speed: 2,
  primaryColor: "#f3f3f3",
  secondaryColor: "#ecebeb",
};

const LineItemPlaceholder = () => (
  <>
    <rect x="0" y="0" rx="0" ry="0" width="70" height="70" />
    <rect x="125" y="0" rx="0" ry="0" width="107" height="12" />
    <rect x="125" y="16" rx="0" ry="0" width="107" height="12" />
  </>
);

const ParagraphPlaceholder = () => (
  <>
    <rect x="0" y="0" rx="0" ry="0" width="250" height="12" />
    <rect x="0" y="20" rx="0" ry="0" width="250" height="12" />
    <rect x="0" y="40" rx="0" ry="0" width="250" height="12" />
  </>
);

const PLACEHOLDER_MAP = {
  lineItem: LineItemPlaceholder,
  paragraph: ParagraphPlaceholder,
};

const getLoaderProps = (defaultProps, newProps = {}) => ({
  ...defaultProps,
  ...newProps,
});

export const ContentPlaceholder = (props) => {
  const classes = classNames("placeholder_loader", props.classname);
  const Placeholder = PLACEHOLDER_MAP[props.loaderType];

  return (
    <ContentLoader
      ariaLabel={props.ariaLabel}
      className={classes}
      {...getLoaderProps(LOADER_DEFAULT_PROPS, props.loaderProps)}
    >
      <Placeholder />
    </ContentLoader>
  );
};

ContentPlaceholder.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  classname: PropTypes.any,
  loaderType: PropTypes.oneOf(Object.keys(PLACEHOLDER_MAP)),
  loaderProps: PropTypes.object.isRequired,
};

ContentPlaceholder.defaultProps = {
  loaderType: "lineItem",
  loaderProps: LOADER_DEFAULT_PROPS,
};

export default ContentPlaceholder;
